/* global PLATFORM, G */
import { curry } from 'lib/util'
import session from 'app/_shared/session'
import { show } from 'lib/sequence/component/state/hidden'
import { set } from 'lib/sequence/component/state/value'
import find from 'lib/sequence/component/children/find'

/**
 * Determines the desired partner of the last message
 * based on the submitter and sets the assignee
 * (partner) of the request to it.
 *
 * The logic is: The partner of "other side" is
 * relevant.
 * - Am I submitter (source) ? Take targetPartner
 * - Am I recipient (target) ? Take sourcePartner
 *
 * @param {Message[]} messages
 * @param {Gaia.AppModule.Spec} module      the current module composition object
 * @param {Gaia.Component.Spec} component   the current action's main component
 * @param {PlatformEvent} event             the event object that triggered this handler
 * @returns {Message[]}
 */
// eslint-disable-next-line no-unused-vars
const setPartner = curry((messages, module, component, event) => {
  const { user } = session(module)
  const { assigneeBox } = find(module[G.STATE][G.ACTION][G.COMPONENT])
  const { name } = find(assigneeBox)

  const submitter = messages[0]?.refs.submitter?.[0]
  const relevantObject = user.key() !== submitter ? 'sourcePartner' : 'targetPartner'
  const partner = messages[0]?.value[relevantObject] || '-'

  if (name) {
    set(name, partner)
    show(assigneeBox)
    PLATFORM === 'web' && module[G.ADAPTER][G.UI].update(module)
  }

  return messages
})

export default setPartner
